/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password'
import { Route as publicLoginRouteImport } from './routes/(public)/login'
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password'
import { Route as AppAuditRouteRouteImport } from './routes/_app/audit/route'
import { Route as AppAuditTasksRouteRouteImport } from './routes/_app/audit-tasks/route'
import { Route as AppAuditorRouteRouteImport } from './routes/_app/auditor/route'
import { Route as AppCertifiedOrgsRouteImport } from './routes/_app/certified-orgs'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDispatchRouteRouteImport } from './routes/_app/dispatch/route'
import { Route as AppOrganicMaterialsRouteImport } from './routes/_app/organic-materials'
import { Route as AppRiskAssessmentRouteRouteImport } from './routes/_app/risk-assessment/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as publicApplyTokenRouteImport } from './routes/(public)/apply.$token'
import { Route as publicMeOfflineRouteImport } from './routes/(public)/me/offline'
import { Route as publicPublicCertSearchRouteImport } from './routes/(public)/public/cert-search'
import { Route as AppAnalyticsIndexRouteImport } from './routes/_app/analytics/index'
import { Route as AppAnalyticsAuditorsRouteImport } from './routes/_app/analytics/auditors'
import { Route as AppAnalyticsCasesRouteImport } from './routes/_app/analytics/cases'
import { Route as AppAnalyticsCertificatesRouteImport } from './routes/_app/analytics/certificates'
import { Route as AppAnalyticsClientsRouteImport } from './routes/_app/analytics/clients'
import { Route as AppAnalyticsFinancialRouteImport } from './routes/_app/analytics/financial'
import { Route as AppAuditReportsPendingReviewRouteImport } from './routes/_app/audit-reports/pending-review'
import { Route as AppAuditTasksIndexRouteImport } from './routes/_app/audit-tasks/index'
import { Route as AppAuditNoticesRouteRouteImport } from './routes/_app/audit/notices/route'
import { Route as AppAuditOrgsRouteRouteImport } from './routes/_app/audit/orgs/route'
import { Route as AppAuditorScheduleRouteImport } from './routes/_app/auditor/schedule'
import { Route as AppBulletinIndexRouteImport } from './routes/_app/bulletin.index'
import { Route as AppBulletinAdminRouteImport } from './routes/_app/bulletin.admin'
import { Route as AppCertificatesIndexRouteImport } from './routes/_app/certificates/index'
import { Route as AppCertificatesIdRouteImport } from './routes/_app/certificates/$id'
import { Route as AppDecisionsIndexRouteImport } from './routes/_app/decisions/index'
import { Route as AppDecisionsIdRouteImport } from './routes/_app/decisions/$id'
import { Route as AppDispatchIndexRouteImport } from './routes/_app/dispatch/index'
import { Route as AppDispatchCaseIdRouteImport } from './routes/_app/dispatch/$caseId'
import { Route as AppDispatchNewRouteImport } from './routes/_app/dispatch/new'
import { Route as AppMeNotificationsRouteImport } from './routes/_app/me/notifications'
import { Route as AppMeProfileRouteImport } from './routes/_app/me/profile'
import { Route as AppMeReportStylesRouteRouteImport } from './routes/_app/me/report-styles/route'
import { Route as AppMeStorageRouteImport } from './routes/_app/me/storage'
import { Route as AppNonConformitiesIndexRouteImport } from './routes/_app/non-conformities/index'
import { Route as AppNonConformitiesListRouteImport } from './routes/_app/non-conformities/list'
import { Route as AppRiskAssessmentIndexRouteImport } from './routes/_app/risk-assessment/index'
import { Route as AppRiskAssessmentCaseIdRouteImport } from './routes/_app/risk-assessment/$caseId'
import { Route as AppRiskAssessmentAnnualRouteImport } from './routes/_app/risk-assessment/annual'
import { Route as AppRiskAssessmentMarketSamplingRouteImport } from './routes/_app/risk-assessment/market-sampling'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAuditLogRouteImport } from './routes/_app/settings/audit-log'
import { Route as AppSettingsClientsRouteImport } from './routes/_app/settings/clients'
import { Route as AppSettingsConflictOfInterestRouteImport } from './routes/_app/settings/conflict-of-interest'
import { Route as AppSettingsContractSourcesRouteImport } from './routes/_app/settings/contract-sources'
import { Route as AppSettingsCropsRouteImport } from './routes/_app/settings/crops'
import { Route as AppSettingsDepartmentsRouteImport } from './routes/_app/settings/departments'
import { Route as AppSettingsDocumentLibraryRouteImport } from './routes/_app/settings/document-library'
import { Route as AppSettingsFormTemplatesRouteImport } from './routes/_app/settings/form-templates'
import { Route as AppSettingsJobFunctionsRouteImport } from './routes/_app/settings/job-functions'
import { Route as AppSettingsJobTitlesRouteImport } from './routes/_app/settings/job-titles'
import { Route as AppSettingsLaboratoriesRouteImport } from './routes/_app/settings/laboratories'
import { Route as AppSettingsMaterialsRouteImport } from './routes/_app/settings/materials'
import { Route as AppSettingsNotificationTemplatesRouteImport } from './routes/_app/settings/notification-templates'
import { Route as AppSettingsNumberingRouteImport } from './routes/_app/settings/numbering'
import { Route as AppSettingsOrganicMaterialLinksRouteImport } from './routes/_app/settings/organic-material-links'
import { Route as AppSettingsRecycleBinRouteImport } from './routes/_app/settings/recycle-bin'
import { Route as AppSettingsStaffRouteImport } from './routes/_app/settings/staff'
import { Route as AppSettingsStandardsRouteImport } from './routes/_app/settings/standards'
import { Route as AppSettingsVerificationCategoriesRouteImport } from './routes/_app/settings/verification-categories'
import { Route as AppSettingsVerificationQualificationsRouteImport } from './routes/_app/settings/verification-qualifications'
import { Route as AppSettingsVerificationSchemesRouteImport } from './routes/_app/settings/verification-schemes'
import { Route as AppSettingsVerificationTypesRouteImport } from './routes/_app/settings/verification-types'
import { Route as AppTcIndexRouteImport } from './routes/_app/tc/index'
import { Route as AppTcIdRouteImport } from './routes/_app/tc/$id'
import { Route as AppAuditTasksTaskIdIndexRouteImport } from './routes/_app/audit-tasks/$taskId.index'
import { Route as AppAuditNoticesIndexRouteImport } from './routes/_app/audit/notices/index'
import { Route as AppAuditOrgsIndexRouteImport } from './routes/_app/audit/orgs/index'
import { Route as AppAuditOrgsClientIdRouteImport } from './routes/_app/audit/orgs/$clientId'
import { Route as AppMeReportStylesIndexRouteImport } from './routes/_app/me/report-styles/index'
import { Route as AppMeReportStylesIdRouteImport } from './routes/_app/me/report-styles/$id'
import { Route as AppSettingsClientsClientIdRouteImport } from './routes/_app/settings/clients.$clientId'
import { Route as AppSettingsRolesIndexRouteImport } from './routes/_app/settings/roles.index'
import { Route as AppSettingsRolesCodeRouteImport } from './routes/_app/settings/roles.$code'
import { Route as AppSettingsStaffIdRouteImport } from './routes/_app/settings/staff_.$id'
import { Route as AppAuditTasksTaskIdFormInstanceIdRouteImport } from './routes/_app/audit-tasks/$taskId.form.$instanceId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: '/(public)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAuditRouteRoute = AppAuditRouteRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAuditTasksRouteRoute = AppAuditTasksRouteRouteImport.update({
  id: '/audit-tasks',
  path: '/audit-tasks',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAuditorRouteRoute = AppAuditorRouteRouteImport.update({
  id: '/auditor',
  path: '/auditor',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCertifiedOrgsRoute = AppCertifiedOrgsRouteImport.update({
  id: '/certified-orgs',
  path: '/certified-orgs',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDispatchRouteRoute = AppDispatchRouteRouteImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganicMaterialsRoute = AppOrganicMaterialsRouteImport.update({
  id: '/organic-materials',
  path: '/organic-materials',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRiskAssessmentRouteRoute = AppRiskAssessmentRouteRouteImport.update({
  id: '/risk-assessment',
  path: '/risk-assessment',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const publicApplyTokenRoute = publicApplyTokenRouteImport.update({
  id: '/(public)/apply/$token',
  path: '/apply/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const publicMeOfflineRoute = publicMeOfflineRouteImport.update({
  id: '/(public)/me/offline',
  path: '/me/offline',
  getParentRoute: () => rootRouteImport,
} as any)
const publicPublicCertSearchRoute = publicPublicCertSearchRouteImport.update({
  id: '/(public)/public/cert-search',
  path: '/public/cert-search',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAnalyticsIndexRoute = AppAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsAuditorsRoute = AppAnalyticsAuditorsRouteImport.update({
  id: '/analytics/auditors',
  path: '/analytics/auditors',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsCasesRoute = AppAnalyticsCasesRouteImport.update({
  id: '/analytics/cases',
  path: '/analytics/cases',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsCertificatesRoute =
  AppAnalyticsCertificatesRouteImport.update({
    id: '/analytics/certificates',
    path: '/analytics/certificates',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAnalyticsClientsRoute = AppAnalyticsClientsRouteImport.update({
  id: '/analytics/clients',
  path: '/analytics/clients',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsFinancialRoute = AppAnalyticsFinancialRouteImport.update({
  id: '/analytics/financial',
  path: '/analytics/financial',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAuditReportsPendingReviewRoute =
  AppAuditReportsPendingReviewRouteImport.update({
    id: '/audit-reports/pending-review',
    path: '/audit-reports/pending-review',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAuditTasksIndexRoute = AppAuditTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuditTasksRouteRoute,
} as any)
const AppAuditNoticesRouteRoute = AppAuditNoticesRouteRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => AppAuditRouteRoute,
} as any)
const AppAuditOrgsRouteRoute = AppAuditOrgsRouteRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AppAuditRouteRoute,
} as any)
const AppAuditorScheduleRoute = AppAuditorScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppAuditorRouteRoute,
} as any)
const AppBulletinIndexRoute = AppBulletinIndexRouteImport.update({
  id: '/bulletin/',
  path: '/bulletin/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBulletinAdminRoute = AppBulletinAdminRouteImport.update({
  id: '/bulletin/admin',
  path: '/bulletin/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCertificatesIndexRoute = AppCertificatesIndexRouteImport.update({
  id: '/certificates/',
  path: '/certificates/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCertificatesIdRoute = AppCertificatesIdRouteImport.update({
  id: '/certificates/$id',
  path: '/certificates/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDecisionsIndexRoute = AppDecisionsIndexRouteImport.update({
  id: '/decisions/',
  path: '/decisions/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDecisionsIdRoute = AppDecisionsIdRouteImport.update({
  id: '/decisions/$id',
  path: '/decisions/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDispatchIndexRoute = AppDispatchIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDispatchRouteRoute,
} as any)
const AppDispatchCaseIdRoute = AppDispatchCaseIdRouteImport.update({
  id: '/$caseId',
  path: '/$caseId',
  getParentRoute: () => AppDispatchRouteRoute,
} as any)
const AppDispatchNewRoute = AppDispatchNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppDispatchRouteRoute,
} as any)
const AppMeNotificationsRoute = AppMeNotificationsRouteImport.update({
  id: '/me/notifications',
  path: '/me/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeProfileRoute = AppMeProfileRouteImport.update({
  id: '/me/profile',
  path: '/me/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeReportStylesRouteRoute = AppMeReportStylesRouteRouteImport.update({
  id: '/me/report-styles',
  path: '/me/report-styles',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMeStorageRoute = AppMeStorageRouteImport.update({
  id: '/me/storage',
  path: '/me/storage',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNonConformitiesIndexRoute = AppNonConformitiesIndexRouteImport.update({
  id: '/non-conformities/',
  path: '/non-conformities/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNonConformitiesListRoute = AppNonConformitiesListRouteImport.update({
  id: '/non-conformities/list',
  path: '/non-conformities/list',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRiskAssessmentIndexRoute = AppRiskAssessmentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRiskAssessmentRouteRoute,
} as any)
const AppRiskAssessmentCaseIdRoute = AppRiskAssessmentCaseIdRouteImport.update({
  id: '/$caseId',
  path: '/$caseId',
  getParentRoute: () => AppRiskAssessmentRouteRoute,
} as any)
const AppRiskAssessmentAnnualRoute = AppRiskAssessmentAnnualRouteImport.update({
  id: '/annual',
  path: '/annual',
  getParentRoute: () => AppRiskAssessmentRouteRoute,
} as any)
const AppRiskAssessmentMarketSamplingRoute =
  AppRiskAssessmentMarketSamplingRouteImport.update({
    id: '/market-sampling',
    path: '/market-sampling',
    getParentRoute: () => AppRiskAssessmentRouteRoute,
  } as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAuditLogRoute = AppSettingsAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsClientsRoute = AppSettingsClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsConflictOfInterestRoute =
  AppSettingsConflictOfInterestRouteImport.update({
    id: '/conflict-of-interest',
    path: '/conflict-of-interest',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsContractSourcesRoute =
  AppSettingsContractSourcesRouteImport.update({
    id: '/contract-sources',
    path: '/contract-sources',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCropsRoute = AppSettingsCropsRouteImport.update({
  id: '/crops',
  path: '/crops',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDepartmentsRoute = AppSettingsDepartmentsRouteImport.update({
  id: '/departments',
  path: '/departments',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDocumentLibraryRoute =
  AppSettingsDocumentLibraryRouteImport.update({
    id: '/document-library',
    path: '/document-library',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsFormTemplatesRoute =
  AppSettingsFormTemplatesRouteImport.update({
    id: '/form-templates',
    path: '/form-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsJobFunctionsRoute = AppSettingsJobFunctionsRouteImport.update({
  id: '/job-functions',
  path: '/job-functions',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsJobTitlesRoute = AppSettingsJobTitlesRouteImport.update({
  id: '/job-titles',
  path: '/job-titles',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLaboratoriesRoute = AppSettingsLaboratoriesRouteImport.update({
  id: '/laboratories',
  path: '/laboratories',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMaterialsRoute = AppSettingsMaterialsRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationTemplatesRoute =
  AppSettingsNotificationTemplatesRouteImport.update({
    id: '/notification-templates',
    path: '/notification-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsNumberingRoute = AppSettingsNumberingRouteImport.update({
  id: '/numbering',
  path: '/numbering',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOrganicMaterialLinksRoute =
  AppSettingsOrganicMaterialLinksRouteImport.update({
    id: '/organic-material-links',
    path: '/organic-material-links',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsRecycleBinRoute = AppSettingsRecycleBinRouteImport.update({
  id: '/recycle-bin',
  path: '/recycle-bin',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsStaffRoute = AppSettingsStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsStandardsRoute = AppSettingsStandardsRouteImport.update({
  id: '/standards',
  path: '/standards',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsVerificationCategoriesRoute =
  AppSettingsVerificationCategoriesRouteImport.update({
    id: '/verification-categories',
    path: '/verification-categories',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsVerificationQualificationsRoute =
  AppSettingsVerificationQualificationsRouteImport.update({
    id: '/verification-qualifications',
    path: '/verification-qualifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsVerificationSchemesRoute =
  AppSettingsVerificationSchemesRouteImport.update({
    id: '/verification-schemes',
    path: '/verification-schemes',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsVerificationTypesRoute =
  AppSettingsVerificationTypesRouteImport.update({
    id: '/verification-types',
    path: '/verification-types',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppTcIndexRoute = AppTcIndexRouteImport.update({
  id: '/tc/',
  path: '/tc/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTcIdRoute = AppTcIdRouteImport.update({
  id: '/tc/$id',
  path: '/tc/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAuditTasksTaskIdIndexRoute =
  AppAuditTasksTaskIdIndexRouteImport.update({
    id: '/$taskId/',
    path: '/$taskId/',
    getParentRoute: () => AppAuditTasksRouteRoute,
  } as any)
const AppAuditNoticesIndexRoute = AppAuditNoticesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuditNoticesRouteRoute,
} as any)
const AppAuditOrgsIndexRoute = AppAuditOrgsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAuditOrgsRouteRoute,
} as any)
const AppAuditOrgsClientIdRoute = AppAuditOrgsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => AppAuditOrgsRouteRoute,
} as any)
const AppMeReportStylesIndexRoute = AppMeReportStylesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMeReportStylesRouteRoute,
} as any)
const AppMeReportStylesIdRoute = AppMeReportStylesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppMeReportStylesRouteRoute,
} as any)
const AppSettingsClientsClientIdRoute =
  AppSettingsClientsClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => AppSettingsClientsRoute,
  } as any)
const AppSettingsRolesIndexRoute = AppSettingsRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsRolesCodeRoute = AppSettingsRolesCodeRouteImport.update({
  id: '/roles/$code',
  path: '/roles/$code',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsStaffIdRoute = AppSettingsStaffIdRouteImport.update({
  id: '/staff_/$id',
  path: '/staff/$id',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppAuditTasksTaskIdFormInstanceIdRoute =
  AppAuditTasksTaskIdFormInstanceIdRouteImport.update({
    id: '/$taskId/form/$instanceId',
    path: '/$taskId/form/$instanceId',
    getParentRoute: () => AppAuditTasksRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof publicIndexRoute
  '/audit': typeof AppAuditRouteRouteWithChildren
  '/audit-tasks': typeof AppAuditTasksRouteRouteWithChildren
  '/auditor': typeof AppAuditorRouteRouteWithChildren
  '/dispatch': typeof AppDispatchRouteRouteWithChildren
  '/risk-assessment': typeof AppRiskAssessmentRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/forgot-password': typeof publicForgotPasswordRoute
  '/login': typeof publicLoginRoute
  '/reset-password': typeof publicResetPasswordRoute
  '/certified-orgs': typeof AppCertifiedOrgsRoute
  '/dashboard': typeof AppDashboardRoute
  '/organic-materials': typeof AppOrganicMaterialsRoute
  '/audit/notices': typeof AppAuditNoticesRouteRouteWithChildren
  '/audit/orgs': typeof AppAuditOrgsRouteRouteWithChildren
  '/me/report-styles': typeof AppMeReportStylesRouteRouteWithChildren
  '/apply/$token': typeof publicApplyTokenRoute
  '/me/offline': typeof publicMeOfflineRoute
  '/public/cert-search': typeof publicPublicCertSearchRoute
  '/analytics/auditors': typeof AppAnalyticsAuditorsRoute
  '/analytics/cases': typeof AppAnalyticsCasesRoute
  '/analytics/certificates': typeof AppAnalyticsCertificatesRoute
  '/analytics/clients': typeof AppAnalyticsClientsRoute
  '/analytics/financial': typeof AppAnalyticsFinancialRoute
  '/audit-reports/pending-review': typeof AppAuditReportsPendingReviewRoute
  '/auditor/schedule': typeof AppAuditorScheduleRoute
  '/bulletin/admin': typeof AppBulletinAdminRoute
  '/certificates/$id': typeof AppCertificatesIdRoute
  '/decisions/$id': typeof AppDecisionsIdRoute
  '/dispatch/$caseId': typeof AppDispatchCaseIdRoute
  '/dispatch/new': typeof AppDispatchNewRoute
  '/me/notifications': typeof AppMeNotificationsRoute
  '/me/profile': typeof AppMeProfileRoute
  '/me/storage': typeof AppMeStorageRoute
  '/non-conformities/list': typeof AppNonConformitiesListRoute
  '/risk-assessment/$caseId': typeof AppRiskAssessmentCaseIdRoute
  '/risk-assessment/annual': typeof AppRiskAssessmentAnnualRoute
  '/risk-assessment/market-sampling': typeof AppRiskAssessmentMarketSamplingRoute
  '/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/settings/clients': typeof AppSettingsClientsRouteWithChildren
  '/settings/conflict-of-interest': typeof AppSettingsConflictOfInterestRoute
  '/settings/contract-sources': typeof AppSettingsContractSourcesRoute
  '/settings/crops': typeof AppSettingsCropsRoute
  '/settings/departments': typeof AppSettingsDepartmentsRoute
  '/settings/document-library': typeof AppSettingsDocumentLibraryRoute
  '/settings/form-templates': typeof AppSettingsFormTemplatesRoute
  '/settings/job-functions': typeof AppSettingsJobFunctionsRoute
  '/settings/job-titles': typeof AppSettingsJobTitlesRoute
  '/settings/laboratories': typeof AppSettingsLaboratoriesRoute
  '/settings/materials': typeof AppSettingsMaterialsRoute
  '/settings/notification-templates': typeof AppSettingsNotificationTemplatesRoute
  '/settings/numbering': typeof AppSettingsNumberingRoute
  '/settings/organic-material-links': typeof AppSettingsOrganicMaterialLinksRoute
  '/settings/recycle-bin': typeof AppSettingsRecycleBinRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/settings/standards': typeof AppSettingsStandardsRoute
  '/settings/verification-categories': typeof AppSettingsVerificationCategoriesRoute
  '/settings/verification-qualifications': typeof AppSettingsVerificationQualificationsRoute
  '/settings/verification-schemes': typeof AppSettingsVerificationSchemesRoute
  '/settings/verification-types': typeof AppSettingsVerificationTypesRoute
  '/tc/$id': typeof AppTcIdRoute
  '/analytics/': typeof AppAnalyticsIndexRoute
  '/audit-tasks/': typeof AppAuditTasksIndexRoute
  '/bulletin/': typeof AppBulletinIndexRoute
  '/certificates/': typeof AppCertificatesIndexRoute
  '/decisions/': typeof AppDecisionsIndexRoute
  '/dispatch/': typeof AppDispatchIndexRoute
  '/non-conformities/': typeof AppNonConformitiesIndexRoute
  '/risk-assessment/': typeof AppRiskAssessmentIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tc/': typeof AppTcIndexRoute
  '/audit/orgs/$clientId': typeof AppAuditOrgsClientIdRoute
  '/me/report-styles/$id': typeof AppMeReportStylesIdRoute
  '/settings/clients/$clientId': typeof AppSettingsClientsClientIdRoute
  '/settings/roles/$code': typeof AppSettingsRolesCodeRoute
  '/settings/staff/$id': typeof AppSettingsStaffIdRoute
  '/audit-tasks/$taskId/': typeof AppAuditTasksTaskIdIndexRoute
  '/audit/notices/': typeof AppAuditNoticesIndexRoute
  '/audit/orgs/': typeof AppAuditOrgsIndexRoute
  '/me/report-styles/': typeof AppMeReportStylesIndexRoute
  '/settings/roles/': typeof AppSettingsRolesIndexRoute
  '/audit-tasks/$taskId/form/$instanceId': typeof AppAuditTasksTaskIdFormInstanceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof publicIndexRoute
  '/audit': typeof AppAuditRouteRouteWithChildren
  '/auditor': typeof AppAuditorRouteRouteWithChildren
  '/forgot-password': typeof publicForgotPasswordRoute
  '/login': typeof publicLoginRoute
  '/reset-password': typeof publicResetPasswordRoute
  '/certified-orgs': typeof AppCertifiedOrgsRoute
  '/dashboard': typeof AppDashboardRoute
  '/organic-materials': typeof AppOrganicMaterialsRoute
  '/apply/$token': typeof publicApplyTokenRoute
  '/me/offline': typeof publicMeOfflineRoute
  '/public/cert-search': typeof publicPublicCertSearchRoute
  '/analytics/auditors': typeof AppAnalyticsAuditorsRoute
  '/analytics/cases': typeof AppAnalyticsCasesRoute
  '/analytics/certificates': typeof AppAnalyticsCertificatesRoute
  '/analytics/clients': typeof AppAnalyticsClientsRoute
  '/analytics/financial': typeof AppAnalyticsFinancialRoute
  '/audit-reports/pending-review': typeof AppAuditReportsPendingReviewRoute
  '/auditor/schedule': typeof AppAuditorScheduleRoute
  '/bulletin/admin': typeof AppBulletinAdminRoute
  '/certificates/$id': typeof AppCertificatesIdRoute
  '/decisions/$id': typeof AppDecisionsIdRoute
  '/dispatch/$caseId': typeof AppDispatchCaseIdRoute
  '/dispatch/new': typeof AppDispatchNewRoute
  '/me/notifications': typeof AppMeNotificationsRoute
  '/me/profile': typeof AppMeProfileRoute
  '/me/storage': typeof AppMeStorageRoute
  '/non-conformities/list': typeof AppNonConformitiesListRoute
  '/risk-assessment/$caseId': typeof AppRiskAssessmentCaseIdRoute
  '/risk-assessment/annual': typeof AppRiskAssessmentAnnualRoute
  '/risk-assessment/market-sampling': typeof AppRiskAssessmentMarketSamplingRoute
  '/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/settings/clients': typeof AppSettingsClientsRouteWithChildren
  '/settings/conflict-of-interest': typeof AppSettingsConflictOfInterestRoute
  '/settings/contract-sources': typeof AppSettingsContractSourcesRoute
  '/settings/crops': typeof AppSettingsCropsRoute
  '/settings/departments': typeof AppSettingsDepartmentsRoute
  '/settings/document-library': typeof AppSettingsDocumentLibraryRoute
  '/settings/form-templates': typeof AppSettingsFormTemplatesRoute
  '/settings/job-functions': typeof AppSettingsJobFunctionsRoute
  '/settings/job-titles': typeof AppSettingsJobTitlesRoute
  '/settings/laboratories': typeof AppSettingsLaboratoriesRoute
  '/settings/materials': typeof AppSettingsMaterialsRoute
  '/settings/notification-templates': typeof AppSettingsNotificationTemplatesRoute
  '/settings/numbering': typeof AppSettingsNumberingRoute
  '/settings/organic-material-links': typeof AppSettingsOrganicMaterialLinksRoute
  '/settings/recycle-bin': typeof AppSettingsRecycleBinRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/settings/standards': typeof AppSettingsStandardsRoute
  '/settings/verification-categories': typeof AppSettingsVerificationCategoriesRoute
  '/settings/verification-qualifications': typeof AppSettingsVerificationQualificationsRoute
  '/settings/verification-schemes': typeof AppSettingsVerificationSchemesRoute
  '/settings/verification-types': typeof AppSettingsVerificationTypesRoute
  '/tc/$id': typeof AppTcIdRoute
  '/analytics': typeof AppAnalyticsIndexRoute
  '/audit-tasks': typeof AppAuditTasksIndexRoute
  '/bulletin': typeof AppBulletinIndexRoute
  '/certificates': typeof AppCertificatesIndexRoute
  '/decisions': typeof AppDecisionsIndexRoute
  '/dispatch': typeof AppDispatchIndexRoute
  '/non-conformities': typeof AppNonConformitiesIndexRoute
  '/risk-assessment': typeof AppRiskAssessmentIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tc': typeof AppTcIndexRoute
  '/audit/orgs/$clientId': typeof AppAuditOrgsClientIdRoute
  '/me/report-styles/$id': typeof AppMeReportStylesIdRoute
  '/settings/clients/$clientId': typeof AppSettingsClientsClientIdRoute
  '/settings/roles/$code': typeof AppSettingsRolesCodeRoute
  '/settings/staff/$id': typeof AppSettingsStaffIdRoute
  '/audit-tasks/$taskId': typeof AppAuditTasksTaskIdIndexRoute
  '/audit/notices': typeof AppAuditNoticesIndexRoute
  '/audit/orgs': typeof AppAuditOrgsIndexRoute
  '/me/report-styles': typeof AppMeReportStylesIndexRoute
  '/settings/roles': typeof AppSettingsRolesIndexRoute
  '/audit-tasks/$taskId/form/$instanceId': typeof AppAuditTasksTaskIdFormInstanceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_app/audit': typeof AppAuditRouteRouteWithChildren
  '/_app/audit-tasks': typeof AppAuditTasksRouteRouteWithChildren
  '/_app/auditor': typeof AppAuditorRouteRouteWithChildren
  '/_app/dispatch': typeof AppDispatchRouteRouteWithChildren
  '/_app/risk-assessment': typeof AppRiskAssessmentRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/(public)/forgot-password': typeof publicForgotPasswordRoute
  '/(public)/login': typeof publicLoginRoute
  '/(public)/reset-password': typeof publicResetPasswordRoute
  '/_app/certified-orgs': typeof AppCertifiedOrgsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/organic-materials': typeof AppOrganicMaterialsRoute
  '/(public)/': typeof publicIndexRoute
  '/_app/audit/notices': typeof AppAuditNoticesRouteRouteWithChildren
  '/_app/audit/orgs': typeof AppAuditOrgsRouteRouteWithChildren
  '/_app/me/report-styles': typeof AppMeReportStylesRouteRouteWithChildren
  '/(public)/apply/$token': typeof publicApplyTokenRoute
  '/(public)/me/offline': typeof publicMeOfflineRoute
  '/(public)/public/cert-search': typeof publicPublicCertSearchRoute
  '/_app/analytics/auditors': typeof AppAnalyticsAuditorsRoute
  '/_app/analytics/cases': typeof AppAnalyticsCasesRoute
  '/_app/analytics/certificates': typeof AppAnalyticsCertificatesRoute
  '/_app/analytics/clients': typeof AppAnalyticsClientsRoute
  '/_app/analytics/financial': typeof AppAnalyticsFinancialRoute
  '/_app/audit-reports/pending-review': typeof AppAuditReportsPendingReviewRoute
  '/_app/auditor/schedule': typeof AppAuditorScheduleRoute
  '/_app/bulletin/admin': typeof AppBulletinAdminRoute
  '/_app/certificates/$id': typeof AppCertificatesIdRoute
  '/_app/decisions/$id': typeof AppDecisionsIdRoute
  '/_app/dispatch/$caseId': typeof AppDispatchCaseIdRoute
  '/_app/dispatch/new': typeof AppDispatchNewRoute
  '/_app/me/notifications': typeof AppMeNotificationsRoute
  '/_app/me/profile': typeof AppMeProfileRoute
  '/_app/me/storage': typeof AppMeStorageRoute
  '/_app/non-conformities/list': typeof AppNonConformitiesListRoute
  '/_app/risk-assessment/$caseId': typeof AppRiskAssessmentCaseIdRoute
  '/_app/risk-assessment/annual': typeof AppRiskAssessmentAnnualRoute
  '/_app/risk-assessment/market-sampling': typeof AppRiskAssessmentMarketSamplingRoute
  '/_app/settings/audit-log': typeof AppSettingsAuditLogRoute
  '/_app/settings/clients': typeof AppSettingsClientsRouteWithChildren
  '/_app/settings/conflict-of-interest': typeof AppSettingsConflictOfInterestRoute
  '/_app/settings/contract-sources': typeof AppSettingsContractSourcesRoute
  '/_app/settings/crops': typeof AppSettingsCropsRoute
  '/_app/settings/departments': typeof AppSettingsDepartmentsRoute
  '/_app/settings/document-library': typeof AppSettingsDocumentLibraryRoute
  '/_app/settings/form-templates': typeof AppSettingsFormTemplatesRoute
  '/_app/settings/job-functions': typeof AppSettingsJobFunctionsRoute
  '/_app/settings/job-titles': typeof AppSettingsJobTitlesRoute
  '/_app/settings/laboratories': typeof AppSettingsLaboratoriesRoute
  '/_app/settings/materials': typeof AppSettingsMaterialsRoute
  '/_app/settings/notification-templates': typeof AppSettingsNotificationTemplatesRoute
  '/_app/settings/numbering': typeof AppSettingsNumberingRoute
  '/_app/settings/organic-material-links': typeof AppSettingsOrganicMaterialLinksRoute
  '/_app/settings/recycle-bin': typeof AppSettingsRecycleBinRoute
  '/_app/settings/staff': typeof AppSettingsStaffRoute
  '/_app/settings/standards': typeof AppSettingsStandardsRoute
  '/_app/settings/verification-categories': typeof AppSettingsVerificationCategoriesRoute
  '/_app/settings/verification-qualifications': typeof AppSettingsVerificationQualificationsRoute
  '/_app/settings/verification-schemes': typeof AppSettingsVerificationSchemesRoute
  '/_app/settings/verification-types': typeof AppSettingsVerificationTypesRoute
  '/_app/tc/$id': typeof AppTcIdRoute
  '/_app/analytics/': typeof AppAnalyticsIndexRoute
  '/_app/audit-tasks/': typeof AppAuditTasksIndexRoute
  '/_app/bulletin/': typeof AppBulletinIndexRoute
  '/_app/certificates/': typeof AppCertificatesIndexRoute
  '/_app/decisions/': typeof AppDecisionsIndexRoute
  '/_app/dispatch/': typeof AppDispatchIndexRoute
  '/_app/non-conformities/': typeof AppNonConformitiesIndexRoute
  '/_app/risk-assessment/': typeof AppRiskAssessmentIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tc/': typeof AppTcIndexRoute
  '/_app/audit/orgs/$clientId': typeof AppAuditOrgsClientIdRoute
  '/_app/me/report-styles/$id': typeof AppMeReportStylesIdRoute
  '/_app/settings/clients/$clientId': typeof AppSettingsClientsClientIdRoute
  '/_app/settings/roles/$code': typeof AppSettingsRolesCodeRoute
  '/_app/settings/staff_/$id': typeof AppSettingsStaffIdRoute
  '/_app/audit-tasks/$taskId/': typeof AppAuditTasksTaskIdIndexRoute
  '/_app/audit/notices/': typeof AppAuditNoticesIndexRoute
  '/_app/audit/orgs/': typeof AppAuditOrgsIndexRoute
  '/_app/me/report-styles/': typeof AppMeReportStylesIndexRoute
  '/_app/settings/roles/': typeof AppSettingsRolesIndexRoute
  '/_app/audit-tasks/$taskId/form/$instanceId': typeof AppAuditTasksTaskIdFormInstanceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/audit-tasks'
    | '/auditor'
    | '/dispatch'
    | '/risk-assessment'
    | '/settings'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/certified-orgs'
    | '/dashboard'
    | '/organic-materials'
    | '/audit/notices'
    | '/audit/orgs'
    | '/me/report-styles'
    | '/apply/$token'
    | '/me/offline'
    | '/public/cert-search'
    | '/analytics/auditors'
    | '/analytics/cases'
    | '/analytics/certificates'
    | '/analytics/clients'
    | '/analytics/financial'
    | '/audit-reports/pending-review'
    | '/auditor/schedule'
    | '/bulletin/admin'
    | '/certificates/$id'
    | '/decisions/$id'
    | '/dispatch/$caseId'
    | '/dispatch/new'
    | '/me/notifications'
    | '/me/profile'
    | '/me/storage'
    | '/non-conformities/list'
    | '/risk-assessment/$caseId'
    | '/risk-assessment/annual'
    | '/risk-assessment/market-sampling'
    | '/settings/audit-log'
    | '/settings/clients'
    | '/settings/conflict-of-interest'
    | '/settings/contract-sources'
    | '/settings/crops'
    | '/settings/departments'
    | '/settings/document-library'
    | '/settings/form-templates'
    | '/settings/job-functions'
    | '/settings/job-titles'
    | '/settings/laboratories'
    | '/settings/materials'
    | '/settings/notification-templates'
    | '/settings/numbering'
    | '/settings/organic-material-links'
    | '/settings/recycle-bin'
    | '/settings/staff'
    | '/settings/standards'
    | '/settings/verification-categories'
    | '/settings/verification-qualifications'
    | '/settings/verification-schemes'
    | '/settings/verification-types'
    | '/tc/$id'
    | '/analytics/'
    | '/audit-tasks/'
    | '/bulletin/'
    | '/certificates/'
    | '/decisions/'
    | '/dispatch/'
    | '/non-conformities/'
    | '/risk-assessment/'
    | '/settings/'
    | '/tc/'
    | '/audit/orgs/$clientId'
    | '/me/report-styles/$id'
    | '/settings/clients/$clientId'
    | '/settings/roles/$code'
    | '/settings/staff/$id'
    | '/audit-tasks/$taskId/'
    | '/audit/notices/'
    | '/audit/orgs/'
    | '/me/report-styles/'
    | '/settings/roles/'
    | '/audit-tasks/$taskId/form/$instanceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/auditor'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/certified-orgs'
    | '/dashboard'
    | '/organic-materials'
    | '/apply/$token'
    | '/me/offline'
    | '/public/cert-search'
    | '/analytics/auditors'
    | '/analytics/cases'
    | '/analytics/certificates'
    | '/analytics/clients'
    | '/analytics/financial'
    | '/audit-reports/pending-review'
    | '/auditor/schedule'
    | '/bulletin/admin'
    | '/certificates/$id'
    | '/decisions/$id'
    | '/dispatch/$caseId'
    | '/dispatch/new'
    | '/me/notifications'
    | '/me/profile'
    | '/me/storage'
    | '/non-conformities/list'
    | '/risk-assessment/$caseId'
    | '/risk-assessment/annual'
    | '/risk-assessment/market-sampling'
    | '/settings/audit-log'
    | '/settings/clients'
    | '/settings/conflict-of-interest'
    | '/settings/contract-sources'
    | '/settings/crops'
    | '/settings/departments'
    | '/settings/document-library'
    | '/settings/form-templates'
    | '/settings/job-functions'
    | '/settings/job-titles'
    | '/settings/laboratories'
    | '/settings/materials'
    | '/settings/notification-templates'
    | '/settings/numbering'
    | '/settings/organic-material-links'
    | '/settings/recycle-bin'
    | '/settings/staff'
    | '/settings/standards'
    | '/settings/verification-categories'
    | '/settings/verification-qualifications'
    | '/settings/verification-schemes'
    | '/settings/verification-types'
    | '/tc/$id'
    | '/analytics'
    | '/audit-tasks'
    | '/bulletin'
    | '/certificates'
    | '/decisions'
    | '/dispatch'
    | '/non-conformities'
    | '/risk-assessment'
    | '/settings'
    | '/tc'
    | '/audit/orgs/$clientId'
    | '/me/report-styles/$id'
    | '/settings/clients/$clientId'
    | '/settings/roles/$code'
    | '/settings/staff/$id'
    | '/audit-tasks/$taskId'
    | '/audit/notices'
    | '/audit/orgs'
    | '/me/report-styles'
    | '/settings/roles'
    | '/audit-tasks/$taskId/form/$instanceId'
  id:
    | '__root__'
    | '/_app'
    | '/_app/audit'
    | '/_app/audit-tasks'
    | '/_app/auditor'
    | '/_app/dispatch'
    | '/_app/risk-assessment'
    | '/_app/settings'
    | '/(public)/forgot-password'
    | '/(public)/login'
    | '/(public)/reset-password'
    | '/_app/certified-orgs'
    | '/_app/dashboard'
    | '/_app/organic-materials'
    | '/(public)/'
    | '/_app/audit/notices'
    | '/_app/audit/orgs'
    | '/_app/me/report-styles'
    | '/(public)/apply/$token'
    | '/(public)/me/offline'
    | '/(public)/public/cert-search'
    | '/_app/analytics/auditors'
    | '/_app/analytics/cases'
    | '/_app/analytics/certificates'
    | '/_app/analytics/clients'
    | '/_app/analytics/financial'
    | '/_app/audit-reports/pending-review'
    | '/_app/auditor/schedule'
    | '/_app/bulletin/admin'
    | '/_app/certificates/$id'
    | '/_app/decisions/$id'
    | '/_app/dispatch/$caseId'
    | '/_app/dispatch/new'
    | '/_app/me/notifications'
    | '/_app/me/profile'
    | '/_app/me/storage'
    | '/_app/non-conformities/list'
    | '/_app/risk-assessment/$caseId'
    | '/_app/risk-assessment/annual'
    | '/_app/risk-assessment/market-sampling'
    | '/_app/settings/audit-log'
    | '/_app/settings/clients'
    | '/_app/settings/conflict-of-interest'
    | '/_app/settings/contract-sources'
    | '/_app/settings/crops'
    | '/_app/settings/departments'
    | '/_app/settings/document-library'
    | '/_app/settings/form-templates'
    | '/_app/settings/job-functions'
    | '/_app/settings/job-titles'
    | '/_app/settings/laboratories'
    | '/_app/settings/materials'
    | '/_app/settings/notification-templates'
    | '/_app/settings/numbering'
    | '/_app/settings/organic-material-links'
    | '/_app/settings/recycle-bin'
    | '/_app/settings/staff'
    | '/_app/settings/standards'
    | '/_app/settings/verification-categories'
    | '/_app/settings/verification-qualifications'
    | '/_app/settings/verification-schemes'
    | '/_app/settings/verification-types'
    | '/_app/tc/$id'
    | '/_app/analytics/'
    | '/_app/audit-tasks/'
    | '/_app/bulletin/'
    | '/_app/certificates/'
    | '/_app/decisions/'
    | '/_app/dispatch/'
    | '/_app/non-conformities/'
    | '/_app/risk-assessment/'
    | '/_app/settings/'
    | '/_app/tc/'
    | '/_app/audit/orgs/$clientId'
    | '/_app/me/report-styles/$id'
    | '/_app/settings/clients/$clientId'
    | '/_app/settings/roles/$code'
    | '/_app/settings/staff_/$id'
    | '/_app/audit-tasks/$taskId/'
    | '/_app/audit/notices/'
    | '/_app/audit/orgs/'
    | '/_app/me/report-styles/'
    | '/_app/settings/roles/'
    | '/_app/audit-tasks/$taskId/form/$instanceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute
  publicLoginRoute: typeof publicLoginRoute
  publicResetPasswordRoute: typeof publicResetPasswordRoute
  publicIndexRoute: typeof publicIndexRoute
  publicApplyTokenRoute: typeof publicApplyTokenRoute
  publicMeOfflineRoute: typeof publicMeOfflineRoute
  publicPublicCertSearchRoute: typeof publicPublicCertSearchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof publicForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/reset-password': {
      id: '/(public)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof publicResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/audit-tasks': {
      id: '/_app/audit-tasks'
      path: '/audit-tasks'
      fullPath: '/audit-tasks'
      preLoaderRoute: typeof AppAuditTasksRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/auditor': {
      id: '/_app/auditor'
      path: '/auditor'
      fullPath: '/auditor'
      preLoaderRoute: typeof AppAuditorRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/certified-orgs': {
      id: '/_app/certified-orgs'
      path: '/certified-orgs'
      fullPath: '/certified-orgs'
      preLoaderRoute: typeof AppCertifiedOrgsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dispatch': {
      id: '/_app/dispatch'
      path: '/dispatch'
      fullPath: '/dispatch'
      preLoaderRoute: typeof AppDispatchRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/organic-materials': {
      id: '/_app/organic-materials'
      path: '/organic-materials'
      fullPath: '/organic-materials'
      preLoaderRoute: typeof AppOrganicMaterialsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/risk-assessment': {
      id: '/_app/risk-assessment'
      path: '/risk-assessment'
      fullPath: '/risk-assessment'
      preLoaderRoute: typeof AppRiskAssessmentRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/(public)/apply/$token': {
      id: '/(public)/apply/$token'
      path: '/apply/$token'
      fullPath: '/apply/$token'
      preLoaderRoute: typeof publicApplyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/me/offline': {
      id: '/(public)/me/offline'
      path: '/me/offline'
      fullPath: '/me/offline'
      preLoaderRoute: typeof publicMeOfflineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/public/cert-search': {
      id: '/(public)/public/cert-search'
      path: '/public/cert-search'
      fullPath: '/public/cert-search'
      preLoaderRoute: typeof publicPublicCertSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/analytics/': {
      id: '/_app/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AppAnalyticsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/analytics/auditors': {
      id: '/_app/analytics/auditors'
      path: '/analytics/auditors'
      fullPath: '/analytics/auditors'
      preLoaderRoute: typeof AppAnalyticsAuditorsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/analytics/cases': {
      id: '/_app/analytics/cases'
      path: '/analytics/cases'
      fullPath: '/analytics/cases'
      preLoaderRoute: typeof AppAnalyticsCasesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/analytics/certificates': {
      id: '/_app/analytics/certificates'
      path: '/analytics/certificates'
      fullPath: '/analytics/certificates'
      preLoaderRoute: typeof AppAnalyticsCertificatesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/analytics/clients': {
      id: '/_app/analytics/clients'
      path: '/analytics/clients'
      fullPath: '/analytics/clients'
      preLoaderRoute: typeof AppAnalyticsClientsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/analytics/financial': {
      id: '/_app/analytics/financial'
      path: '/analytics/financial'
      fullPath: '/analytics/financial'
      preLoaderRoute: typeof AppAnalyticsFinancialRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/audit-reports/pending-review': {
      id: '/_app/audit-reports/pending-review'
      path: '/audit-reports/pending-review'
      fullPath: '/audit-reports/pending-review'
      preLoaderRoute: typeof AppAuditReportsPendingReviewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/audit-tasks/': {
      id: '/_app/audit-tasks/'
      path: '/'
      fullPath: '/audit-tasks/'
      preLoaderRoute: typeof AppAuditTasksIndexRouteImport
      parentRoute: typeof AppAuditTasksRouteRoute
    }
    '/_app/audit/notices': {
      id: '/_app/audit/notices'
      path: '/notices'
      fullPath: '/audit/notices'
      preLoaderRoute: typeof AppAuditNoticesRouteRouteImport
      parentRoute: typeof AppAuditRouteRoute
    }
    '/_app/audit/orgs': {
      id: '/_app/audit/orgs'
      path: '/orgs'
      fullPath: '/audit/orgs'
      preLoaderRoute: typeof AppAuditOrgsRouteRouteImport
      parentRoute: typeof AppAuditRouteRoute
    }
    '/_app/auditor/schedule': {
      id: '/_app/auditor/schedule'
      path: '/schedule'
      fullPath: '/auditor/schedule'
      preLoaderRoute: typeof AppAuditorScheduleRouteImport
      parentRoute: typeof AppAuditorRouteRoute
    }
    '/_app/bulletin/': {
      id: '/_app/bulletin/'
      path: '/bulletin'
      fullPath: '/bulletin/'
      preLoaderRoute: typeof AppBulletinIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/bulletin/admin': {
      id: '/_app/bulletin/admin'
      path: '/bulletin/admin'
      fullPath: '/bulletin/admin'
      preLoaderRoute: typeof AppBulletinAdminRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/certificates/': {
      id: '/_app/certificates/'
      path: '/certificates'
      fullPath: '/certificates/'
      preLoaderRoute: typeof AppCertificatesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/certificates/$id': {
      id: '/_app/certificates/$id'
      path: '/certificates/$id'
      fullPath: '/certificates/$id'
      preLoaderRoute: typeof AppCertificatesIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/decisions/': {
      id: '/_app/decisions/'
      path: '/decisions'
      fullPath: '/decisions/'
      preLoaderRoute: typeof AppDecisionsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/decisions/$id': {
      id: '/_app/decisions/$id'
      path: '/decisions/$id'
      fullPath: '/decisions/$id'
      preLoaderRoute: typeof AppDecisionsIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dispatch/': {
      id: '/_app/dispatch/'
      path: '/'
      fullPath: '/dispatch/'
      preLoaderRoute: typeof AppDispatchIndexRouteImport
      parentRoute: typeof AppDispatchRouteRoute
    }
    '/_app/dispatch/$caseId': {
      id: '/_app/dispatch/$caseId'
      path: '/$caseId'
      fullPath: '/dispatch/$caseId'
      preLoaderRoute: typeof AppDispatchCaseIdRouteImport
      parentRoute: typeof AppDispatchRouteRoute
    }
    '/_app/dispatch/new': {
      id: '/_app/dispatch/new'
      path: '/new'
      fullPath: '/dispatch/new'
      preLoaderRoute: typeof AppDispatchNewRouteImport
      parentRoute: typeof AppDispatchRouteRoute
    }
    '/_app/me/notifications': {
      id: '/_app/me/notifications'
      path: '/me/notifications'
      fullPath: '/me/notifications'
      preLoaderRoute: typeof AppMeNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/me/profile': {
      id: '/_app/me/profile'
      path: '/me/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AppMeProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/me/report-styles': {
      id: '/_app/me/report-styles'
      path: '/me/report-styles'
      fullPath: '/me/report-styles'
      preLoaderRoute: typeof AppMeReportStylesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/me/storage': {
      id: '/_app/me/storage'
      path: '/me/storage'
      fullPath: '/me/storage'
      preLoaderRoute: typeof AppMeStorageRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/non-conformities/': {
      id: '/_app/non-conformities/'
      path: '/non-conformities'
      fullPath: '/non-conformities/'
      preLoaderRoute: typeof AppNonConformitiesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/non-conformities/list': {
      id: '/_app/non-conformities/list'
      path: '/non-conformities/list'
      fullPath: '/non-conformities/list'
      preLoaderRoute: typeof AppNonConformitiesListRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/risk-assessment/': {
      id: '/_app/risk-assessment/'
      path: '/'
      fullPath: '/risk-assessment/'
      preLoaderRoute: typeof AppRiskAssessmentIndexRouteImport
      parentRoute: typeof AppRiskAssessmentRouteRoute
    }
    '/_app/risk-assessment/$caseId': {
      id: '/_app/risk-assessment/$caseId'
      path: '/$caseId'
      fullPath: '/risk-assessment/$caseId'
      preLoaderRoute: typeof AppRiskAssessmentCaseIdRouteImport
      parentRoute: typeof AppRiskAssessmentRouteRoute
    }
    '/_app/risk-assessment/annual': {
      id: '/_app/risk-assessment/annual'
      path: '/annual'
      fullPath: '/risk-assessment/annual'
      preLoaderRoute: typeof AppRiskAssessmentAnnualRouteImport
      parentRoute: typeof AppRiskAssessmentRouteRoute
    }
    '/_app/risk-assessment/market-sampling': {
      id: '/_app/risk-assessment/market-sampling'
      path: '/market-sampling'
      fullPath: '/risk-assessment/market-sampling'
      preLoaderRoute: typeof AppRiskAssessmentMarketSamplingRouteImport
      parentRoute: typeof AppRiskAssessmentRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/audit-log': {
      id: '/_app/settings/audit-log'
      path: '/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AppSettingsAuditLogRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/clients': {
      id: '/_app/settings/clients'
      path: '/clients'
      fullPath: '/settings/clients'
      preLoaderRoute: typeof AppSettingsClientsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/conflict-of-interest': {
      id: '/_app/settings/conflict-of-interest'
      path: '/conflict-of-interest'
      fullPath: '/settings/conflict-of-interest'
      preLoaderRoute: typeof AppSettingsConflictOfInterestRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/contract-sources': {
      id: '/_app/settings/contract-sources'
      path: '/contract-sources'
      fullPath: '/settings/contract-sources'
      preLoaderRoute: typeof AppSettingsContractSourcesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/crops': {
      id: '/_app/settings/crops'
      path: '/crops'
      fullPath: '/settings/crops'
      preLoaderRoute: typeof AppSettingsCropsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/departments': {
      id: '/_app/settings/departments'
      path: '/departments'
      fullPath: '/settings/departments'
      preLoaderRoute: typeof AppSettingsDepartmentsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/document-library': {
      id: '/_app/settings/document-library'
      path: '/document-library'
      fullPath: '/settings/document-library'
      preLoaderRoute: typeof AppSettingsDocumentLibraryRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/form-templates': {
      id: '/_app/settings/form-templates'
      path: '/form-templates'
      fullPath: '/settings/form-templates'
      preLoaderRoute: typeof AppSettingsFormTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/job-functions': {
      id: '/_app/settings/job-functions'
      path: '/job-functions'
      fullPath: '/settings/job-functions'
      preLoaderRoute: typeof AppSettingsJobFunctionsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/job-titles': {
      id: '/_app/settings/job-titles'
      path: '/job-titles'
      fullPath: '/settings/job-titles'
      preLoaderRoute: typeof AppSettingsJobTitlesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/laboratories': {
      id: '/_app/settings/laboratories'
      path: '/laboratories'
      fullPath: '/settings/laboratories'
      preLoaderRoute: typeof AppSettingsLaboratoriesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/materials': {
      id: '/_app/settings/materials'
      path: '/materials'
      fullPath: '/settings/materials'
      preLoaderRoute: typeof AppSettingsMaterialsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notification-templates': {
      id: '/_app/settings/notification-templates'
      path: '/notification-templates'
      fullPath: '/settings/notification-templates'
      preLoaderRoute: typeof AppSettingsNotificationTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/numbering': {
      id: '/_app/settings/numbering'
      path: '/numbering'
      fullPath: '/settings/numbering'
      preLoaderRoute: typeof AppSettingsNumberingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/organic-material-links': {
      id: '/_app/settings/organic-material-links'
      path: '/organic-material-links'
      fullPath: '/settings/organic-material-links'
      preLoaderRoute: typeof AppSettingsOrganicMaterialLinksRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/recycle-bin': {
      id: '/_app/settings/recycle-bin'
      path: '/recycle-bin'
      fullPath: '/settings/recycle-bin'
      preLoaderRoute: typeof AppSettingsRecycleBinRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/staff': {
      id: '/_app/settings/staff'
      path: '/staff'
      fullPath: '/settings/staff'
      preLoaderRoute: typeof AppSettingsStaffRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/standards': {
      id: '/_app/settings/standards'
      path: '/standards'
      fullPath: '/settings/standards'
      preLoaderRoute: typeof AppSettingsStandardsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/verification-categories': {
      id: '/_app/settings/verification-categories'
      path: '/verification-categories'
      fullPath: '/settings/verification-categories'
      preLoaderRoute: typeof AppSettingsVerificationCategoriesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/verification-qualifications': {
      id: '/_app/settings/verification-qualifications'
      path: '/verification-qualifications'
      fullPath: '/settings/verification-qualifications'
      preLoaderRoute: typeof AppSettingsVerificationQualificationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/verification-schemes': {
      id: '/_app/settings/verification-schemes'
      path: '/verification-schemes'
      fullPath: '/settings/verification-schemes'
      preLoaderRoute: typeof AppSettingsVerificationSchemesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/verification-types': {
      id: '/_app/settings/verification-types'
      path: '/verification-types'
      fullPath: '/settings/verification-types'
      preLoaderRoute: typeof AppSettingsVerificationTypesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/tc/': {
      id: '/_app/tc/'
      path: '/tc'
      fullPath: '/tc/'
      preLoaderRoute: typeof AppTcIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tc/$id': {
      id: '/_app/tc/$id'
      path: '/tc/$id'
      fullPath: '/tc/$id'
      preLoaderRoute: typeof AppTcIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/audit-tasks/$taskId/': {
      id: '/_app/audit-tasks/$taskId/'
      path: '/$taskId'
      fullPath: '/audit-tasks/$taskId/'
      preLoaderRoute: typeof AppAuditTasksTaskIdIndexRouteImport
      parentRoute: typeof AppAuditTasksRouteRoute
    }
    '/_app/audit/notices/': {
      id: '/_app/audit/notices/'
      path: '/'
      fullPath: '/audit/notices/'
      preLoaderRoute: typeof AppAuditNoticesIndexRouteImport
      parentRoute: typeof AppAuditNoticesRouteRoute
    }
    '/_app/audit/orgs/': {
      id: '/_app/audit/orgs/'
      path: '/'
      fullPath: '/audit/orgs/'
      preLoaderRoute: typeof AppAuditOrgsIndexRouteImport
      parentRoute: typeof AppAuditOrgsRouteRoute
    }
    '/_app/audit/orgs/$clientId': {
      id: '/_app/audit/orgs/$clientId'
      path: '/$clientId'
      fullPath: '/audit/orgs/$clientId'
      preLoaderRoute: typeof AppAuditOrgsClientIdRouteImport
      parentRoute: typeof AppAuditOrgsRouteRoute
    }
    '/_app/me/report-styles/': {
      id: '/_app/me/report-styles/'
      path: '/'
      fullPath: '/me/report-styles/'
      preLoaderRoute: typeof AppMeReportStylesIndexRouteImport
      parentRoute: typeof AppMeReportStylesRouteRoute
    }
    '/_app/me/report-styles/$id': {
      id: '/_app/me/report-styles/$id'
      path: '/$id'
      fullPath: '/me/report-styles/$id'
      preLoaderRoute: typeof AppMeReportStylesIdRouteImport
      parentRoute: typeof AppMeReportStylesRouteRoute
    }
    '/_app/settings/clients/$clientId': {
      id: '/_app/settings/clients/$clientId'
      path: '/$clientId'
      fullPath: '/settings/clients/$clientId'
      preLoaderRoute: typeof AppSettingsClientsClientIdRouteImport
      parentRoute: typeof AppSettingsClientsRoute
    }
    '/_app/settings/roles/': {
      id: '/_app/settings/roles/'
      path: '/roles'
      fullPath: '/settings/roles/'
      preLoaderRoute: typeof AppSettingsRolesIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/roles/$code': {
      id: '/_app/settings/roles/$code'
      path: '/roles/$code'
      fullPath: '/settings/roles/$code'
      preLoaderRoute: typeof AppSettingsRolesCodeRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/staff_/$id': {
      id: '/_app/settings/staff_/$id'
      path: '/staff/$id'
      fullPath: '/settings/staff/$id'
      preLoaderRoute: typeof AppSettingsStaffIdRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/audit-tasks/$taskId/form/$instanceId': {
      id: '/_app/audit-tasks/$taskId/form/$instanceId'
      path: '/$taskId/form/$instanceId'
      fullPath: '/audit-tasks/$taskId/form/$instanceId'
      preLoaderRoute: typeof AppAuditTasksTaskIdFormInstanceIdRouteImport
      parentRoute: typeof AppAuditTasksRouteRoute
    }
  }
}

interface AppAuditNoticesRouteRouteChildren {
  AppAuditNoticesIndexRoute: typeof AppAuditNoticesIndexRoute
}

const AppAuditNoticesRouteRouteChildren: AppAuditNoticesRouteRouteChildren = {
  AppAuditNoticesIndexRoute: AppAuditNoticesIndexRoute,
}

const AppAuditNoticesRouteRouteWithChildren =
  AppAuditNoticesRouteRoute._addFileChildren(AppAuditNoticesRouteRouteChildren)

interface AppAuditOrgsRouteRouteChildren {
  AppAuditOrgsClientIdRoute: typeof AppAuditOrgsClientIdRoute
  AppAuditOrgsIndexRoute: typeof AppAuditOrgsIndexRoute
}

const AppAuditOrgsRouteRouteChildren: AppAuditOrgsRouteRouteChildren = {
  AppAuditOrgsClientIdRoute: AppAuditOrgsClientIdRoute,
  AppAuditOrgsIndexRoute: AppAuditOrgsIndexRoute,
}

const AppAuditOrgsRouteRouteWithChildren =
  AppAuditOrgsRouteRoute._addFileChildren(AppAuditOrgsRouteRouteChildren)

interface AppAuditRouteRouteChildren {
  AppAuditNoticesRouteRoute: typeof AppAuditNoticesRouteRouteWithChildren
  AppAuditOrgsRouteRoute: typeof AppAuditOrgsRouteRouteWithChildren
}

const AppAuditRouteRouteChildren: AppAuditRouteRouteChildren = {
  AppAuditNoticesRouteRoute: AppAuditNoticesRouteRouteWithChildren,
  AppAuditOrgsRouteRoute: AppAuditOrgsRouteRouteWithChildren,
}

const AppAuditRouteRouteWithChildren = AppAuditRouteRoute._addFileChildren(
  AppAuditRouteRouteChildren,
)

interface AppAuditTasksRouteRouteChildren {
  AppAuditTasksIndexRoute: typeof AppAuditTasksIndexRoute
  AppAuditTasksTaskIdIndexRoute: typeof AppAuditTasksTaskIdIndexRoute
  AppAuditTasksTaskIdFormInstanceIdRoute: typeof AppAuditTasksTaskIdFormInstanceIdRoute
}

const AppAuditTasksRouteRouteChildren: AppAuditTasksRouteRouteChildren = {
  AppAuditTasksIndexRoute: AppAuditTasksIndexRoute,
  AppAuditTasksTaskIdIndexRoute: AppAuditTasksTaskIdIndexRoute,
  AppAuditTasksTaskIdFormInstanceIdRoute:
    AppAuditTasksTaskIdFormInstanceIdRoute,
}

const AppAuditTasksRouteRouteWithChildren =
  AppAuditTasksRouteRoute._addFileChildren(AppAuditTasksRouteRouteChildren)

interface AppAuditorRouteRouteChildren {
  AppAuditorScheduleRoute: typeof AppAuditorScheduleRoute
}

const AppAuditorRouteRouteChildren: AppAuditorRouteRouteChildren = {
  AppAuditorScheduleRoute: AppAuditorScheduleRoute,
}

const AppAuditorRouteRouteWithChildren = AppAuditorRouteRoute._addFileChildren(
  AppAuditorRouteRouteChildren,
)

interface AppDispatchRouteRouteChildren {
  AppDispatchCaseIdRoute: typeof AppDispatchCaseIdRoute
  AppDispatchNewRoute: typeof AppDispatchNewRoute
  AppDispatchIndexRoute: typeof AppDispatchIndexRoute
}

const AppDispatchRouteRouteChildren: AppDispatchRouteRouteChildren = {
  AppDispatchCaseIdRoute: AppDispatchCaseIdRoute,
  AppDispatchNewRoute: AppDispatchNewRoute,
  AppDispatchIndexRoute: AppDispatchIndexRoute,
}

const AppDispatchRouteRouteWithChildren =
  AppDispatchRouteRoute._addFileChildren(AppDispatchRouteRouteChildren)

interface AppRiskAssessmentRouteRouteChildren {
  AppRiskAssessmentCaseIdRoute: typeof AppRiskAssessmentCaseIdRoute
  AppRiskAssessmentAnnualRoute: typeof AppRiskAssessmentAnnualRoute
  AppRiskAssessmentMarketSamplingRoute: typeof AppRiskAssessmentMarketSamplingRoute
  AppRiskAssessmentIndexRoute: typeof AppRiskAssessmentIndexRoute
}

const AppRiskAssessmentRouteRouteChildren: AppRiskAssessmentRouteRouteChildren =
  {
    AppRiskAssessmentCaseIdRoute: AppRiskAssessmentCaseIdRoute,
    AppRiskAssessmentAnnualRoute: AppRiskAssessmentAnnualRoute,
    AppRiskAssessmentMarketSamplingRoute: AppRiskAssessmentMarketSamplingRoute,
    AppRiskAssessmentIndexRoute: AppRiskAssessmentIndexRoute,
  }

const AppRiskAssessmentRouteRouteWithChildren =
  AppRiskAssessmentRouteRoute._addFileChildren(
    AppRiskAssessmentRouteRouteChildren,
  )

interface AppSettingsClientsRouteChildren {
  AppSettingsClientsClientIdRoute: typeof AppSettingsClientsClientIdRoute
}

const AppSettingsClientsRouteChildren: AppSettingsClientsRouteChildren = {
  AppSettingsClientsClientIdRoute: AppSettingsClientsClientIdRoute,
}

const AppSettingsClientsRouteWithChildren =
  AppSettingsClientsRoute._addFileChildren(AppSettingsClientsRouteChildren)

interface AppSettingsRouteRouteChildren {
  AppSettingsAuditLogRoute: typeof AppSettingsAuditLogRoute
  AppSettingsClientsRoute: typeof AppSettingsClientsRouteWithChildren
  AppSettingsConflictOfInterestRoute: typeof AppSettingsConflictOfInterestRoute
  AppSettingsContractSourcesRoute: typeof AppSettingsContractSourcesRoute
  AppSettingsCropsRoute: typeof AppSettingsCropsRoute
  AppSettingsDepartmentsRoute: typeof AppSettingsDepartmentsRoute
  AppSettingsDocumentLibraryRoute: typeof AppSettingsDocumentLibraryRoute
  AppSettingsFormTemplatesRoute: typeof AppSettingsFormTemplatesRoute
  AppSettingsJobFunctionsRoute: typeof AppSettingsJobFunctionsRoute
  AppSettingsJobTitlesRoute: typeof AppSettingsJobTitlesRoute
  AppSettingsLaboratoriesRoute: typeof AppSettingsLaboratoriesRoute
  AppSettingsMaterialsRoute: typeof AppSettingsMaterialsRoute
  AppSettingsNotificationTemplatesRoute: typeof AppSettingsNotificationTemplatesRoute
  AppSettingsNumberingRoute: typeof AppSettingsNumberingRoute
  AppSettingsOrganicMaterialLinksRoute: typeof AppSettingsOrganicMaterialLinksRoute
  AppSettingsRecycleBinRoute: typeof AppSettingsRecycleBinRoute
  AppSettingsStaffRoute: typeof AppSettingsStaffRoute
  AppSettingsStandardsRoute: typeof AppSettingsStandardsRoute
  AppSettingsVerificationCategoriesRoute: typeof AppSettingsVerificationCategoriesRoute
  AppSettingsVerificationQualificationsRoute: typeof AppSettingsVerificationQualificationsRoute
  AppSettingsVerificationSchemesRoute: typeof AppSettingsVerificationSchemesRoute
  AppSettingsVerificationTypesRoute: typeof AppSettingsVerificationTypesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsRolesCodeRoute: typeof AppSettingsRolesCodeRoute
  AppSettingsStaffIdRoute: typeof AppSettingsStaffIdRoute
  AppSettingsRolesIndexRoute: typeof AppSettingsRolesIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAuditLogRoute: AppSettingsAuditLogRoute,
  AppSettingsClientsRoute: AppSettingsClientsRouteWithChildren,
  AppSettingsConflictOfInterestRoute: AppSettingsConflictOfInterestRoute,
  AppSettingsContractSourcesRoute: AppSettingsContractSourcesRoute,
  AppSettingsCropsRoute: AppSettingsCropsRoute,
  AppSettingsDepartmentsRoute: AppSettingsDepartmentsRoute,
  AppSettingsDocumentLibraryRoute: AppSettingsDocumentLibraryRoute,
  AppSettingsFormTemplatesRoute: AppSettingsFormTemplatesRoute,
  AppSettingsJobFunctionsRoute: AppSettingsJobFunctionsRoute,
  AppSettingsJobTitlesRoute: AppSettingsJobTitlesRoute,
  AppSettingsLaboratoriesRoute: AppSettingsLaboratoriesRoute,
  AppSettingsMaterialsRoute: AppSettingsMaterialsRoute,
  AppSettingsNotificationTemplatesRoute: AppSettingsNotificationTemplatesRoute,
  AppSettingsNumberingRoute: AppSettingsNumberingRoute,
  AppSettingsOrganicMaterialLinksRoute: AppSettingsOrganicMaterialLinksRoute,
  AppSettingsRecycleBinRoute: AppSettingsRecycleBinRoute,
  AppSettingsStaffRoute: AppSettingsStaffRoute,
  AppSettingsStandardsRoute: AppSettingsStandardsRoute,
  AppSettingsVerificationCategoriesRoute:
    AppSettingsVerificationCategoriesRoute,
  AppSettingsVerificationQualificationsRoute:
    AppSettingsVerificationQualificationsRoute,
  AppSettingsVerificationSchemesRoute: AppSettingsVerificationSchemesRoute,
  AppSettingsVerificationTypesRoute: AppSettingsVerificationTypesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsRolesCodeRoute: AppSettingsRolesCodeRoute,
  AppSettingsStaffIdRoute: AppSettingsStaffIdRoute,
  AppSettingsRolesIndexRoute: AppSettingsRolesIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppMeReportStylesRouteRouteChildren {
  AppMeReportStylesIdRoute: typeof AppMeReportStylesIdRoute
  AppMeReportStylesIndexRoute: typeof AppMeReportStylesIndexRoute
}

const AppMeReportStylesRouteRouteChildren: AppMeReportStylesRouteRouteChildren =
  {
    AppMeReportStylesIdRoute: AppMeReportStylesIdRoute,
    AppMeReportStylesIndexRoute: AppMeReportStylesIndexRoute,
  }

const AppMeReportStylesRouteRouteWithChildren =
  AppMeReportStylesRouteRoute._addFileChildren(
    AppMeReportStylesRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppAuditRouteRoute: typeof AppAuditRouteRouteWithChildren
  AppAuditTasksRouteRoute: typeof AppAuditTasksRouteRouteWithChildren
  AppAuditorRouteRoute: typeof AppAuditorRouteRouteWithChildren
  AppDispatchRouteRoute: typeof AppDispatchRouteRouteWithChildren
  AppRiskAssessmentRouteRoute: typeof AppRiskAssessmentRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppCertifiedOrgsRoute: typeof AppCertifiedOrgsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppOrganicMaterialsRoute: typeof AppOrganicMaterialsRoute
  AppMeReportStylesRouteRoute: typeof AppMeReportStylesRouteRouteWithChildren
  AppAnalyticsAuditorsRoute: typeof AppAnalyticsAuditorsRoute
  AppAnalyticsCasesRoute: typeof AppAnalyticsCasesRoute
  AppAnalyticsCertificatesRoute: typeof AppAnalyticsCertificatesRoute
  AppAnalyticsClientsRoute: typeof AppAnalyticsClientsRoute
  AppAnalyticsFinancialRoute: typeof AppAnalyticsFinancialRoute
  AppAuditReportsPendingReviewRoute: typeof AppAuditReportsPendingReviewRoute
  AppBulletinAdminRoute: typeof AppBulletinAdminRoute
  AppCertificatesIdRoute: typeof AppCertificatesIdRoute
  AppDecisionsIdRoute: typeof AppDecisionsIdRoute
  AppMeNotificationsRoute: typeof AppMeNotificationsRoute
  AppMeProfileRoute: typeof AppMeProfileRoute
  AppMeStorageRoute: typeof AppMeStorageRoute
  AppNonConformitiesListRoute: typeof AppNonConformitiesListRoute
  AppTcIdRoute: typeof AppTcIdRoute
  AppAnalyticsIndexRoute: typeof AppAnalyticsIndexRoute
  AppBulletinIndexRoute: typeof AppBulletinIndexRoute
  AppCertificatesIndexRoute: typeof AppCertificatesIndexRoute
  AppDecisionsIndexRoute: typeof AppDecisionsIndexRoute
  AppNonConformitiesIndexRoute: typeof AppNonConformitiesIndexRoute
  AppTcIndexRoute: typeof AppTcIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAuditRouteRoute: AppAuditRouteRouteWithChildren,
  AppAuditTasksRouteRoute: AppAuditTasksRouteRouteWithChildren,
  AppAuditorRouteRoute: AppAuditorRouteRouteWithChildren,
  AppDispatchRouteRoute: AppDispatchRouteRouteWithChildren,
  AppRiskAssessmentRouteRoute: AppRiskAssessmentRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppCertifiedOrgsRoute: AppCertifiedOrgsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppOrganicMaterialsRoute: AppOrganicMaterialsRoute,
  AppMeReportStylesRouteRoute: AppMeReportStylesRouteRouteWithChildren,
  AppAnalyticsAuditorsRoute: AppAnalyticsAuditorsRoute,
  AppAnalyticsCasesRoute: AppAnalyticsCasesRoute,
  AppAnalyticsCertificatesRoute: AppAnalyticsCertificatesRoute,
  AppAnalyticsClientsRoute: AppAnalyticsClientsRoute,
  AppAnalyticsFinancialRoute: AppAnalyticsFinancialRoute,
  AppAuditReportsPendingReviewRoute: AppAuditReportsPendingReviewRoute,
  AppBulletinAdminRoute: AppBulletinAdminRoute,
  AppCertificatesIdRoute: AppCertificatesIdRoute,
  AppDecisionsIdRoute: AppDecisionsIdRoute,
  AppMeNotificationsRoute: AppMeNotificationsRoute,
  AppMeProfileRoute: AppMeProfileRoute,
  AppMeStorageRoute: AppMeStorageRoute,
  AppNonConformitiesListRoute: AppNonConformitiesListRoute,
  AppTcIdRoute: AppTcIdRoute,
  AppAnalyticsIndexRoute: AppAnalyticsIndexRoute,
  AppBulletinIndexRoute: AppBulletinIndexRoute,
  AppCertificatesIndexRoute: AppCertificatesIndexRoute,
  AppDecisionsIndexRoute: AppDecisionsIndexRoute,
  AppNonConformitiesIndexRoute: AppNonConformitiesIndexRoute,
  AppTcIndexRoute: AppTcIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicLoginRoute: publicLoginRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  publicIndexRoute: publicIndexRoute,
  publicApplyTokenRoute: publicApplyTokenRoute,
  publicMeOfflineRoute: publicMeOfflineRoute,
  publicPublicCertSearchRoute: publicPublicCertSearchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
